<div class="confirm-modal ig-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <mat-icon class="main-icon" [ngStyle]="{ 'color': data.confirmModalIcon==='done'?'green':data.confirmModalIcon==='help'?'#41abf3':'red'}">{{data.confirmModalIcon||'warning'}}</mat-icon>
    <h3>{{ data.confirmModalTitle }}</h3>
    <div class="description" [innerHTML]="data.confirmModalDescription"></div>

    <div *ngIf="data.confirmCheckboxDescription">
        <div #confirmCheckbox><mat-checkbox [(ngModel)]="isChecked">I confirm I understand this:</mat-checkbox></div>
        <p style="color: #67757c;font-size: 14px;margin: 4px 0 12px 0">{{data.confirmCheckboxDescription}}</p>
    </div>

    <ig-row [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="warn-btn" #confirmButton [color]="data.color||'warn'" size="md"
                       [isAsync]="data.isAsync"
                       (trigger)="confirm($event)">
                {{ data.confirmModalConfirmButtonText }}
            </ig-button>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
        {{ data.confirmModalCancelButtonText }}
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/confirm.modal/confirm.modal.component.html